import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";

var scope_0 = require('E:/Web/react-nails/react-nails-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1628b565df694992eb0da13a26e876ef.js')["default"];

var scope_1 = require('E:/Web/react-nails/react-nails-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/17a2ab52a473b760212584ceea70ede2.js')["default"];

var scope_2 = require('E:/Web/react-nails/react-nails-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js')["default"];

var scope_3 = require('E:/Web/react-nails/react-nails-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/22e845cafac2396f3273e443d28cb239.js')["default"];

var scope_4 = require('E:/Web/react-nails/react-nails-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/28b957d3eb8438ffb7364beaa4e3e8c4.js')["default"];

var scope_5 = require('E:/Web/react-nails/react-nails-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3021058c710669753a4c5793d6615a5b.js')["default"];

var scope_6 = require('E:/Web/react-nails/react-nails-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3c52fc335e93686b5a790a51a28c4471.js')["default"];

var scope_7 = require('E:/Web/react-nails/react-nails-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/463ae523ffdced46918608036e054893.js')["default"];

var scope_8 = require('E:/Web/react-nails/react-nails-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/46cf54c5f04b542f8b3f90d262f9d961.js')["default"];

var scope_9 = require('E:/Web/react-nails/react-nails-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/70771ef4fe747f6283672faebac03a23.js')["default"];

var scope_10 = require('E:/Web/react-nails/react-nails-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/73602286bf1382610e70ad9b3d462e07.js')["default"];

var scope_11 = require('E:/Web/react-nails/react-nails-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/75e1c772a7188953dd57a86075b38291.js')["default"];

var scope_12 = require('E:/Web/react-nails/react-nails-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7e7812ece81e5d65c9c5e534fc52e68f.js')["default"];

var scope_13 = require('E:/Web/react-nails/react-nails-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ad065f2afcdf248baf49027e8a9ae45f.js')["default"];

var scope_14 = require('E:/Web/react-nails/react-nails-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b8566dee9292477606361e64587a4356.js')["default"];

var scope_15 = require('E:/Web/react-nails/react-nails-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d1451e1f65aad7b1d3cd07ecc59abf4a.js')["default"];

var scope_16 = require('E:/Web/react-nails/react-nails-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d3fed92592e9ff0ad46014b0e2855b19.js')["default"];

var scope_17 = require('E:/Web/react-nails/react-nails-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/efcacea1c1c5afd4c1eb73be0b54acc9.js')["default"];

var scope_18 = require('E:/Web/react-nails/react-nails-docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fb0cef6fa5b4777679855addbcfe5db5.js')["default"];

export default Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7, scope_8, scope_9, scope_10, scope_11, scope_12, scope_13, scope_14, scope_15, scope_16, scope_17, scope_18);